"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgMedicalSupplies = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 72 72", fill: "none" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "currentColor", d: "M37.78 55.31v-10.5h10.49v-4.25H37.78V30.07h-4.25v10.49h-10.5v4.25h10.5v10.5h4.25z" }), (0, jsx_runtime_1.jsx)("path", { fill: "currentColor", d: "M67.25 23.92a7.564 7.564 0 0 0-7.57-7.23h-4.43l4.25 4.25h.18c1.78 0 3.25 1.4 3.33 3.18l1.66 36.13H6.64L8.3 24.12a3.326 3.326 0 0 1 3.33-3.18H51V10.3c0-2.97-2.41-5.38-5.38-5.38H25.68c-2.97 0-5.38 2.41-5.38 5.38v6.38h-8.67c-4.06 0-7.39 3.18-7.57 7.23L2.2 64.48h66.91l-1.86-40.57ZM24.55 10.3c0-.62.51-1.13 1.13-1.13h19.94c.62 0 1.13.51 1.13 1.13v6.38h-22.2V10.3Z" })] }))); };
exports.default = SvgMedicalSupplies;
